// extracted by mini-css-extract-plugin
export default {"content":"Jts+xHIR","media":"a4mLhybR"};